import React from 'react';
import { useSelector } from 'react-redux';
import { formatNumber } from '../../utils/Helper';
import BarGraph from '../common/BarGraph';

const InvestmentSummaryCard = ({
  title,
  amount,
  graphData,
  totalAmount,
  noDataMessage,
}) => {
  const locale = useSelector((state) => state.languageReducer.language);
  return (
    <div className="bg-[#F3F3F3] dark:bg-slate-800 dark:text-slate-200 p-4 rounded-md">
      <div className="flex justify-between items-center mb-2">
        <div className="font-semibold">{title}</div>
        <div className="font-semibold">
          {formatNumber(amount, { locale, decimalPlaces: 2 })}
        </div>
      </div>
      {amount > 0 && (
        <div className="block rounded-md">
          <BarGraph graphData={graphData} totalAmount={totalAmount} />
        </div>
      )}
      {amount === 0 && noDataMessage && (
        <div className="bg-white p-5 block md:flex items-center justify-between rounded-md my-10">
          <p className="text-base font-semibold text-brandBlue text-center dark:text-black">
            {noDataMessage}
          </p>
        </div>
      )}
      <div className="text-[#85919F]"></div>
    </div>
  );
};

export default InvestmentSummaryCard;
